import React from "react";
import ContactPageMD from "../components/Contact/ContactPageMD";
const Contact = () => {
  return <ContactPageMD />;
};

export default Contact;
